import { put, call, takeEvery } from "redux-saga/effects"
import { authRequest } from "src/engine/modules/authRequest"
import { READ_LIST } from "../actions/types"
import { readListSuccess, readListError } from "../actions/creators/read"

// read list saga
function* requestRead(action) {
  const { basicUrl, query } = action.config
  try {
    const response = yield call(authRequest, { url: basicUrl, params: query })

    yield put(readListSuccess(action, response))
  } catch (error) {
    yield put(readListError(action, error))
  }
}

export default function* readSaga() {
  yield takeEvery(READ_LIST, requestRead)
}
